define([
    'lib/tentacle/tentacle',
    'modules/rore/controls/namesselect2'
], (Tentacle, NamesSelect2) => {

    // Registering most used custom rore controls
    Tentacle.registerControls({
        namesSelect2: NamesSelect2
    });

});
